import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import {
  SetupUnloadingDashboard,
  SetupUnloadingDashboardCondition,
} from 'models/setup/mobile/UnloadingDashboard';
import { callApi } from 'utils/ApiUtil';

/**
 * 하역대시보드 > 품목 현황 조회
 */
export const findUnloadingItemList = async (condition: SetupUnloadingDashboardCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: '/v1/mobilesetup/dashboard/item',
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };
  const response: CommonResponse<SetupUnloadingDashboard> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as SetupUnloadingDashboard;
};

/**
 * 하역대시보드 > Box 현황 조회
 */
export const findUnloadingBoxList = async (condition: SetupUnloadingDashboardCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: '/v1/mobilesetup/dashboard/box',
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };
  const response: CommonResponse<SetupUnloadingDashboard> = await callApi(request);

  return (response.successOrNot === 'Y' ? response.data : null) as SetupUnloadingDashboard;
};
